import axios from 'axios';
import download from 'downloadjs';

import {
  serverAction,
  serverClinicians,
  serverEnrolments,
  serverEventTypes,
  serverInclusionCriterias,
  serverLogin,
  serverPatients,
  serverPrograms,
  serverResultSet,
  serverSchedulingPatterns,
  serverStatistics,
  serverUsers,
  serverUserSchedules,
  serverVariables,
  timeToWait,
} from './constants_comms';

// Funció genral per realitzar les peticions al servidor i processar la resposta
const processRequest = async (options) => {
  try {
    const response = await axios(options);
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      return error.response.status;
    }
    if (error.request) {
      // The request was made but no response was received
      return 'timeOut';
    }
    // Something happened in setting up the request that triggered an Error
    console.log(`Error: ${error.message}`);
    return 'generic';
  }
};

// ************************* (INICI) Bloc dels DELETES ************************* //
// Esborra un clínic
export async function deleteClinician(id, token) {
  const options = {
    url: `${serverClinicians}${id}`,
    method: 'DELETE',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Esborra un pacient
export async function deletePatient(id, token) {
  const options = {
    url: `${serverPatients}${id}`,
    method: 'DELETE',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Elimina una clínic de l'equip d'una inscripció
export async function removeClinician(idEnrolment, idClinician, token) {
  const options = {
    url: `${serverEnrolments}${idEnrolment}/team-members/${idClinician}`,
    method: 'DELETE',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Elimina una inscripció
export async function removeEnrolment(idEnrolment, token) {
  const options = {
    url: `${serverEnrolments}${idEnrolment}`,
    method: 'DELETE',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Elimina un event del pacient
export async function removeEvent(idPatient, idEvent, token) {
  const options = {
    url: `${serverPatients}${idPatient}/events/${idEvent}`,
    method: 'DELETE',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Elimina un clinic de la llista de clínics amb accés un programa
export async function removeProgram(idClinician, idProgram, token) {
  const options = {
    url: `${serverPrograms}${idProgram}/clinicianAccesses/${idClinician}`,
    method: 'DELETE',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}
// ************************* (FI) Bloc dels DELETES ************************* //

// ************************* (INICI) Bloc dels GETS ************************* //
// Demanam tots els Scheduling Patterns
export async function getAllSchedulingPatterns(token) {
  const options = {
    url: `${serverSchedulingPatterns}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demana les estadístiques bàsiques
export async function getBasicStats(token) {
  const options = {
    url: serverStatistics,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demanam el llistat de clínics
export async function getClinicians(token) {
  const options = {
    url: serverClinicians,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demanam la informació d'un clínic
export async function getClinicianInfo(id, token) {
  const options = {
    url: `${serverClinicians}${id}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demanam el llistat de programes d'un clínic
export async function getClinicianPrograms(id, token) {
  const options = {
    url: `${serverPrograms}clinician/${id}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demanam el llistat de enrolments d'un clínic
export async function getClinicianEnrolments(id, token) {
  const options = {
    url: `${serverEnrolments}clinician/${id}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}


// Demanam info d'un enrolment
export async function getEnrolment(id, token) {
  const options = {
    url: `${serverEnrolments}${id}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demanam tots els enrolments
export async function getEnrolments(token) {
  const options = {
    url: serverEnrolments,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demanam tots els userSchedules (formularis) d'una subscripció
export async function getEnrolmentUserSchedules(id, token) {
  const options = {
    url: `${serverUserSchedules}enrolment/${id}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demanam TOTS els eventTypes
export async function getEventTypes(token) {
  const options = {
    url: serverEventTypes,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demana les variables d'un programa
export async function getFormVariables(idProgram, formName, token) {
  const options = {
    url: `${serverVariables}program/${idProgram}/form/${formName}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}


// Demanam TOTS els inclusionCriteria
export async function getInclusionCriterias(token) {
  const options = {
    url: serverInclusionCriterias,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// ******************** Continguts segons idioma ************************************ //
// Demana les traduccions generiques (noms de programes i formularis)
export async function getInternalCommonContents(token) {
  const options = {
    url: `${serverPrograms}common/languages/platform/web`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  }
  return processRequest(options);
}

// Demana els textos d'un programa per a un idioma
export async function getProgramLanguageContents(programId, token) {
  const options = {
    url: `${serverPrograms}${programId}/languages/platform/web`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  }
  return processRequest(options);
}

// Obtenir nova contrasenya
export async function getNewPassword(username) {
  const options = {
    url: `${serverAction}password-reset/link/${username}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  };
  return processRequest(options);
}

// Demana les tasques programades (formularis) d'un enrolment
export async function getEnrolmentSchedules(idEnrolment, token) {
  const options = {
    url: `${serverUserSchedules}enrolment/${idEnrolment}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demana les tasques programades (formularis) de l'usuari que fa la petició
export async function getOwnUserSchedules(token) {
  const options = {
    url: `${serverUserSchedules}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demanam els enrolments d'un pacient
export async function getPatientEnrolments(id, token) {
  const options = {
    url: `${serverEnrolments}patient/${id}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demanam el llistat de pacients
export async function getPatients(token) {
  const options = {
    url: serverPatients,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demanam el llistat de pacients del programa
export async function getProgramPatients(idProgram, token) {
  const options = {
    url: `${serverPatients}program/${idProgram}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demanam la informació d'un pacient
export async function getPatientInfo(id, token) {
  const options = {
    url: `${serverPatients}${id}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demanam les tasques programades d'un pacient.
// Ho empr quan el qui fa la consulta no és el propi pacient.
// Quan el que fa la consulta és el pacient, emprar getOwnUserSchedules
export async function getPatientUserSchedules(id, token) {
  const options = {
    url: `${serverUserSchedules}patient/${id}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demanam els eventTypes d'un programa
export async function getProgramEventTypes(id, token) {
  const options = {
    url: `${serverEventTypes}program/${id}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demana la informació de configuració d'un programa
export async function getProgramConfiguration(id, token) {
  const options = {
    url: `${serverPrograms}programConfiguration/${id}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demana la informació d'un programa
export async function getProgramInfo(id, token) {
  const options = {
    url: `${serverPrograms}${id}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demanam el llistat de programes
export async function getPrograms(token) {
  const options = {
    url: serverPrograms,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

export async function getProgramXls(id, token) {  
  const options = {
    url: `${serverPrograms}programConfiguration/xls/${id}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/xls',
      'Content-Type': 'application/xls',
      'Access-Token': token,
    },
    responseType: 'blob'
  };
  try {
    const res = await processRequest(options);
    if (res && res.headers) {
      const fileName = res.headers["x-suggested-filename"] || "downloaded_file.xlsx";
      download(res.data, fileName);
    } else {
      console.error("Download error:", res);
    }  
  } catch (error) {
    console.error('Hi ha hagut un error:');
    console.error(error); 
  }
}

// Demanam els Scheduling Patterns d'un programa
export async function getProgramSchedulingPatterns(id, token) {
  const options = {
    url: `${serverSchedulingPatterns}program/${id}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demana les variables associades al programa
export async function getProgramVariables(id, token) {
  const options = {
    url: `${serverVariables}program/${id}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// Demana un userSchedule en concret
export async function getUserSchedule(id, token) {
  const options = {
    url: `${serverUserSchedules}/${id}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}
// Demana userSchedules d'un usuari concret
export async function getUserSchedules(token) {
  const options = {
    url: `${serverUserSchedules}`,
    method: 'GET',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
  };
  return processRequest(options);
}

// ************************* (FI) Bloc dels GETS ************************* //

// ************************* (INICI) Bloc dels PATCHS ************************* //
// Actualitzam un clínic ja creat
export async function updateClinician(data, id, token) {
  const options = {
    url: `${serverClinicians}${id}`,
    method: 'PATCH',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
    data,
  };
  return processRequest(options);
}

// Actualitzam un pacient ja creat
export async function updatePatient(data, id, token) {
  const options = {
    url: `${serverPatients}${id}`,
    method: 'PATCH',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
    data,
  };
  return processRequest(options);
}

// Per modificar events d'un pacient
// ATENCIÓ: el servidor només té implementada la creació i eliminació d'esdeveniments.
// De moment (25/09/20) aquesta funció no fa res, la deix al codi per si en un futur la necessit
export async function updatePatientEvents(data, id, token) {
  const options = {
    url: `${serverPatients}${id}`,
    method: 'PATCH',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
    data: {
      patient: {
        events: data,
      },
    },
  };
  return processRequest(options);
}

// Actualitzam un programa ja creat
export async function updateProgram(data, id, token) {
  const options = {
    url: `${serverPrograms}${id}`,
    method: 'PATCH',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
    data,
  };
  return processRequest(options);
}
// ************************* (FI) Bloc dels PATCHS ************************* //

// ************************* (INICI) Bloc dels POSTS ************************* //
// Per afegir clínics a un programa
export async function addCliniciansToProgram(data, id, token) {
  const options = {
    url: `${serverPrograms}${id}/clinicianAccesses`,
    method: 'POST',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
    data: { accesses: data },
  };
  return processRequest(options);
}

// Per afegir clínics a l'equip de l'enrolment
export async function addEnrolmentTeamMembers(data, id, token) {
  const options = {
    url: `${serverEnrolments}${id}/team-members`,
    method: 'POST',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
    data: {
      members: data,
    },
  };
  return processRequest(options);
}

// Per afegir events a un pacient
export async function addEventsToPatient(data, enrolmentId, id, token) {
  const options = {
    url: `${serverPatients}${id}/events`,
    method: 'POST',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
    data: {
      events: data,
      enrolment: enrolmentId,
    },
  };
  return processRequest(options);
}


// Per crear un UserSchedule d'un pacient
export async function addUserSchedule(data, token) {
  const options = {
    url: `${serverUserSchedules}`,
    method: 'POST',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
    data: {
      userSchedule: data,
    },
  };
  return processRequest(options);
}

// Per inscriure un pacient a un programa
export async function enrolPatientToProgram(idUser, idProgram, token) {
  const options = {
    url: `${serverEnrolments}`,
    method: 'POST',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
    data: {
      enrolment: {
        patient: idUser,
        program: idProgram,
      },
    },
  };
  return processRequest(options);
}

// Demanam per logejar-nos
export async function getAccess(username, password) {
  const options = {
    url: serverLogin,
    method: 'POST',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    data: {
      username,
      password,
    },
  };
  return processRequest(options);
}

// Crear clínic
export async function newClinician(data, token) {
  const options = {
    url: serverClinicians,
    method: 'POST',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
    data,
  };
  return processRequest(options);
}

// Crear pacient
export async function newPatient(data, token) {
  const options = {
    url: serverPatients,
    method: 'POST',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
    data,
  };
  return processRequest(options);
}

// Crear un programa
export async function newProgram(data, token) {
  const options = {
    url: serverPrograms,
    method: 'POST',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
    data,
  };
  return processRequest(options);
}


// Crea un resultSet
export async function newResultSet(data, token) {
  // console.log('result set val: ');
  // console.log(data);
  const options = {
    url: serverResultSet,
    method: 'POST',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
    data,
  };
  return processRequest(options);
}

// Per canviar la contrasenya en cas d'haver-la oblidat
export async function resetPassword(username, password, token) {
  const options = {
    url: `${serverAction}password-reset`,
    method: 'POST',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
    data: {
      username,
      password,
      token,
    },
  };
  return processRequest(options);
}
// ************************* (FI) Bloc dels POSTS ************************* //

// ************************* (INICI) Bloc dels PUTS ************************* //
// Canvi de la contrasenya d'un usuari
export async function changePassword(password, id, token) {
  const options = {
    url: `${serverUsers}${id}/password`,
    method: 'PUT',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
    data: password,
  };
  return processRequest(options);
}

// Modifica els rols (admin o no admin) dels clínics d'un enrolment
export async function modifyEnrolmentTeamAdmin(data, idEnrolment, token) {
  const options = {
    url: `${serverEnrolments}${idEnrolment}/team-members/`,
    method: 'PUT',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
    data: {
      members: data,
    },
  };
  return processRequest(options);
}

// Modifica un schedule
export async function modifyUserSchedule(dataSchedule, idSchedule, token) {
  const options = {
    url: `${serverUserSchedules}${idSchedule}`,
    method: 'PUT',
    timeout: timeToWait,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Token': token,
    },
    data: {
      userSchedule: dataSchedule,
    },
  };
  return processRequest(options);
}
// ************************* (FI) Bloc dels PUTS ************************* //
